import { getAuth } from 'firebase/auth';

/**
 * Drop-in replacement for `fetch()` that automatically attaches the
 * current Firebase user's ID token as a Bearer Authorization header.
 *
 * Usage:  `const res = await authFetch('/api/projects/…', { method: 'POST', body });`
 *
 * If no user is signed in the request is still sent (without the header),
 * so the server will respond with 401.
 */
export async function authFetch(
  input: RequestInfo | URL,
  init?: RequestInit,
): Promise<Response> {
  const token = await getAuth().currentUser?.getIdToken();

  const headers = new Headers(init?.headers);
  if (token) {
    headers.set('Authorization', `Bearer ${token}`);
  }

  return fetch(input, { ...init, headers });
}
